import { Tab } from "@headlessui/react";
import { useParams } from "react-router-dom";
import { auth } from "../../database/firebase";
import useRoomId from "../../hooks/DatabseCollection/useRoomId";
import TabName from "../Tab/Tab";
import AboutTab from "../TabComponents/AboutTab";
import DashboardTab from "../TabComponents/DashboardTab";
import MeetingsTab from "../TabComponents/MeetingsTab";
import MembersTab from "../TabComponents/MembersTab";
import RequestTab from "../TabComponents/RequestTab";
import SettingsTab from "../TabComponents/SettingsTab";
import { useAuthState } from "react-firebase-hooks/auth";
import { useEffect, useState } from "react";

export default function RoomTabs() {
  const [user] = useAuthState(auth);
  const { roomId } = useParams();
  const { roomDetail } = useRoomId(roomId);
  const [roomOwner, setRoomOwner] = useState(false);

  useEffect(() => {
    if (roomDetail?.createdUserId === user.uid) setRoomOwner(true);
  }, [roomDetail?.createdUserId, user.uid]);

  return (
    <div className="w-full px-2 lg:px-0">
      <Tab.Group>
        <div className="lg:max-w-4xl">
          <Tab.List className="flex items-center space-x-9 border-b-2 border-gray-200 overflow-x-scroll lg:overflow-x-hidden">
            <TabName tabName="Dashboard" />
            {roomOwner && <TabName tabName="requests" />}
            <TabName tabName="meetings" />
            <TabName tabName="members" />
            {roomOwner && <TabName tabName="settings" />}
            <TabName tabName="about" />
          </Tab.List>
        </div>
        <Tab.Panels className="mt-10">
          <Tab.Panel>
            <DashboardTab />
          </Tab.Panel>
          {roomOwner && (
            <Tab.Panel>
              <RequestTab />
            </Tab.Panel>
          )}
          <Tab.Panel>
            <MeetingsTab />
          </Tab.Panel>
          <Tab.Panel>
            <MembersTab />
          </Tab.Panel>
          {roomOwner && (
            <Tab.Panel>
              <SettingsTab />
            </Tab.Panel>
          )}

          <Tab.Panel>
            <AboutTab />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}
